module.exports = __webpack_public_path__ + "static_pc/img/footLogoLeft.8f655a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/footLogoLeft.png
// module id = YaVn
// module chunks = 1